module.exports = __webpack_public_path__ + "img/hero-11.c0c937c2.png";